/**
 * Created by lycheng on 2017/11/29.
 * 悬浮的狗，返回顶部
 */
import * as userApi from 'js/api/user'
import { layer } from 'js/libs/utils-layer'
import { cookie } from 'js/libs/utils-cookie'
import { isWorkday, isWorkTime ,setQueryString } from 'js/libs/utils'
import { config } from 'config'
import './utils-announcement'

function initZcScript(w, d, e, x) {
    w[e] = function () {
      w.cbk = w.cbk || [];
      w.cbk.push(arguments);
    };
    x = d.createElement("script");
    x.async = true;
    x.id = "zhichiScript";
    x.className = "im-btn";
    x.src =
      "https://chat.sobot.com/chat/frame/v2/entrance.js?sysnum=1f851a5acb6e4f408a3e3e5487750951";
    d.body.appendChild(x);
}

function initZc(userInfo) {
    const nick = userInfo.nickname;
    let nickLogin = userInfo.login;
    const nickMiddle = nickLogin.length / 2;
    const isEven = nickLogin.length % 2 === 0;
    const nickEncry = isEven ? nickMiddle : Math.ceil(nickMiddle) - 2;
    nickLogin =
      nickLogin.length > 5
        ? nickLogin.replace(
            nickLogin.substring(nickEncry, nickEncry + 2),
            "***"
          )
        : nickLogin;
    userApi.aesEncry(userInfo.uid).then(r=>{
      let uid = r.data
      const isZcBack = window.location.search.includes("isZc=1");
      initZcScript(window, document, "zc");
      const args = {
        customField7: uid,
      };
      const prms = {
        uid,
      };
      zc("config", {
        uname: nick || nickLogin,
        custom: true, // 设置自定义
        color: "2277e6",
        customer_fields: JSON.stringify(args),
        params: JSON.stringify(prms),
        partnerid: uid,
        auto_expand: isZcBack,
      });
      zc("dynamic_ready");
    })
}
/**
 * 右侧悬浮
 * @param s:距离顶部的高度
 */
function suspension (s, isIndex) {
  var $suspension = $('.suspension')
  if (!$suspension.length) {
    return
  }
  var show400 = !(isWorkTime() && isWorkday())
  if (show400) {
    $('#feedback_btn').before(`
    <div class="suspension-item-wrap suspension-phone-wrap">
      <i class="icons icons-suspension-phone"></i>
      <div>
        <div class="suspension-number-title">服务热线</div>
        <p class="suspension-number-phone">4000-199-199</p>
      </div>
    </div>
    `)
  }
  var $backTop = $('.suspension-back-top')
  var $susIcon = $('.sus-icon')
  var winH = $(window).height()
  $(window).scroll(function () {
    var scrollTop = $(window).scrollTop()
    if (scrollTop < s - winH / 2) {
      $suspension.css({
        position: 'absolute',
        top: s + 'px'
      })
    } else {
      $suspension.css({
        position: 'fixed',
        top: '50%'
      })
    }
    if (scrollTop > winH / 2) {
      $backTop.show()
    } else {
      $backTop.hide()
    }
  })
  $(window).scroll()
  $backTop.click(function () {
    $('body, html').animate({'scrollTop': 0}, 500)
    return false
  })

  function checkImLog(){
    userApi.getUserinfo().then(result => {
      if (result.code === 80000) {
        $(".im-icon").removeClass("im-btn");
        $(".im-icon").click(function () {
          const jumpBack =
            typeof window !== "undefined"
              ? Base64.encode(setQueryString("isZc", 1))
              : "";
          window.location.href = `${config.PASSPORT}/login?jump=${jumpBack}`;
        });
      } else {
        initZc(result.data);
      }
    })
  }

  checkImLog()

  // $(".im-icon").click(function () {
  //   checkImLog()
  // });
}
export { suspension }



// WEBPACK FOOTER //
// ./src/js/libs/utils-suspension.js